// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1217T","label":"CategoryService_label__1_17L","location":"CategoryService_location__3Ou_x"};